import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import CaseCountDisplay from 'Components/CaseCountDisplay/CaseCountDisplay.jsx';
import { connect } from 'react-redux';
import GDTableHeader from '../GDTable/GDTableHeader';
import GDTableFooter from '../GDTable/GDTableFooter';
import GDTableContainer from '../GDTable/GDTableContainer';
import './GridAccordion.scss';
import AgGridTable from '../AgGridTable/AgGridTable';
import WizardAccordion from 'Components/wizard-accordion/WizardAccordion.jsx';

class GridAccordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleColumns: this.selectVisibleColumns(
                this.props.report.dataColumns,
            ),
            selectedFileType: {},
            selectedExportType: {},
            detailViewAction: {
                name: this.props.translations.viewDetail,
                description: 'view detail description',
                linkedReportId: 'detail-view',
                linkedReportKey: '',
                actionType: 'ROW',
                reportLinks: [],
            },
        };

        this.attachBindings();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.report !== this.props.report && newProps.report.dataColumns) {
            this.setState({
                visibleColumns: this.selectVisibleColumns(
                    newProps.report.dataColumns,
                ),
            });
        }
    }

    attachBindings() {
        this.selectOption = this.selectOption.bind(this);
        this.updateVisibleColumns = this.updateVisibleColumns.bind(this);
        this.selectVisibleColumns = this.selectVisibleColumns.bind(this);
    }

    selectOption(event, option) {
        this.setState({ [event.target.name]: option });
    }

    updateVisibleColumns(columns) {
        const newVisibleColumns = this.selectVisibleColumns(columns);
        this.setState({ visibleColumns: this.props.addIconsToGDTableHeadersList(newVisibleColumns, this.props.userPermissions) });
        this.props.saveCurrentlyVisibleColumns(newVisibleColumns); // still save the list with hidden columns present
    }

    selectVisibleColumns(columns = []) {
        const isUserHasSelectedColumn = columns.filter((column) => {
            return (column.userIsVisible === true || column.isSelected === true) && column.description !== '' && column.displayType !== 'ICON';
        });
        return columns
            .filter((column) => {
                return (isUserHasSelectedColumn.length > 0 ? column.userIsVisible || column.isSelected : column.defaultIsVisible) && column.displayType !== 'NONE' && column.displayType !== 'EXPORT_ONLY';
            })
            .sort((columnA, columnB) => {
                return Number(columnA.displayOrder) - Number(columnB.displayOrder);
            });
    }

    render() {
        const { detailViewAction } = this.state;
        const wrapperClass = classnames(`gd-table ${this.props.reportName == "Unresolved RTI" ? "scroll-Y" : ""}`, {
            [this.props.extraClass]: this.props.extraClass,
        });
        const rowActions = this.props.report.columnToFilterMaps
            && this.props.report.columnToFilterMaps.length
            ? this.props.report.columnToFilterMaps.map((action) => {
                const uniqueKey = action.reportColumnLinks.reduce((accumulator, item) => {
                    return `${accumulator}_${item.toFilterId}`;
                }, '');

                return {
                    callback: (rowId) => {
                        const rowToUse = this.props.data.find((row) => row['seq_key'] === rowId); // eslint-disable-line

                        if (rowToUse) {
                            this.props.handleRowAction({ row: rowToUse, action });
                        }
                    },
                    id: uniqueKey,
                    text: action.name,
                    primary: false,
                };
            })
            : [];

        rowActions.unshift({
            callback: (rowId) => {
                const rowDetail = this.props.data.find((row) => {
                    return row.seq_key === rowId;
                });
                this.props.onRowClick(null, rowDetail);
            },
            id: `${detailViewAction.linkedReportId}`,
            text: `${detailViewAction.name}`,
            primary: true,
        });

        return (
            <div className={`${this.props.tableCss} ${wrapperClass} customAccordionTableContainer`}>
                {this.props.report.dataColumns && this.props.report.dataColumns?.length > 0 && ( <>
                    <WizardAccordion                        
                        isGridCompact={this.props?.isGridCompact}
                        width="calc(100% + 15px)"
                        className=""
                        isOpen={this.props.isOpen}
                        handleOnlyOnSymbol={true}
                        toggleAccordion={this.props.toggleAccordion}
                        headerText={
                            <GDTableHeader
                                {...this.props}
                                tableCss = {this.props.tableCss}
                                isrelatedSearchLoaded={this.props.isrelatedSearchLoaded}
                                showCollapseExpandButton={this.props.isOpen}
                                title={this.props.report.name}
                                tableName={this.props.tableName}
                                merchantDetail={this.props.merchantDetail}
                                titleRequired={this.props.titleRequired}
                                columns={this.props.report.dataColumns}
                                exporting={this.props.exporting}
                                totalRecords={this.props.totalRecords}
                                recordsCountText={this.props.recordsCountText}
                                currentPage={this.props.currentPage}
                                recordsShown={this.props.recordsShown}
                                filterText={this.props.filterText}
                                onSearchChange={this.props.onSearchChange}
                                canSearch={this.props.report.canSearch}
                                isNextPage={this.props.isNextPage}
                                canExport={this.props.report.isExportable}
                                exportAction={this.props.exportAction}
                                toggleFileExport={this.props.toggleFileExport}
                                filterExportIsVisible={this.props.filterExportIsVisible}
                                selectOption={this.selectOption}
                                selectedFileType={this.state.selectedFileType}
                                selectedExportType={this.state.selectedExportType}
                                translations={this.props.translations}
                                canManageColumns={this.props.report.canManageColumns}
                                updateVisibleColumns={this.updateVisibleColumns}
                                dateFormat={this.props.dateFormat}
                                timeBoxData={this.props.timeBoxData}
                                refreshTimeFeed={this.props.refreshTimeFeed}
                                recordCountRequired={this.props.recordCountRequired}
                                routeToPreviousPage={this.props.routeToPreviousPage}
                                showBackToReport={this.props.showBackToReport}
                                exportFileName={this.props.exportFileName}
                                queueDesc={this.props.queueDesc}
                            />
                        }
                    >
                        <div className="gd-table__main-container" >
                            {this.props.isAgGrid &&
                                <AgGridTable
                                    rowHeight={this.props.rowHeight}
                                    isrelatedSearchLoaded={this.props.isrelatedSearchLoaded}
                                    isGridCompact={this.props?.isGridCompact}
                                    isCellborder={this.props?.isCellborder}
                                    onCloseClick={this.props.onCloseClick}
                                    isNewQueueLanding={this.props.isNewQueueLanding}
                                    isRefreshed={this.props.isRefreshed}
                                    columns={this.state.visibleColumns}
                                    rowActions={rowActions}
                                    totalRecords={this.props.totalRecords}
                                    totalPages={this.props.totalPages}
                                    recordsCountText={this.props.recordsCountText}
                                    currentPage={this.props.currentPage}
                                    recordsShown={this.props.recordsShown}
                                    pageHandler={this.props.pageHandler}
                                    translations={this.props.translations}
                                    isNextPage={this.props.isNextPage}
                                    id={`${this.props.report.name}_GDTableFooter`}
                                    isPagable={this.props.isPagable}
                                    rowData={this.props.data}
                                    triggerText={this.props.actionButtonText}
                                    actions={this.props.report.actions}
                                    rowActionClick={this.props.rowActionClick}
                                    onCheckboxClick={this.props.onCheckboxClick}
                                    selectedRows={this.props.selectedRows}
                                    isCheckboxOnRowRequired={this.props.isCheckboxOnRowRequired}
                                    onBookMarked={this.props.onBookMarked}
                                    bookMarkedRows={this.props.bookMarkedRows}
                                    handleSort={this.props.handleSort}
                                    queueId={this.props.queueId}
                                    lazyLoadPageNumber={this.props.lazyLoadPageNumber}
                                    sort={this.props.sort}
                                    appliedFilterParams={this.props.appliedFilterParams}
                                    agLoader={this.props.agLoader}
                                    pageName={this.props.pageName}
                                    setRecordCount={this.props.setRecordCount}
                                    serverSideData={this.props.serverSideData}
                                    setAggridCaseData={this.props.setAggridCaseData}
                                    filterTypeId={this.props.filterTypeId}
                                    getFormattedData={this.props.getFormattedData}
                                    user={this.props.user}
                                    pageListId={this.props.pageListId}
                                    actionWidth={this.props.actionWidth}
                                    isMerchantPortal={this.props.isMerchantPortal}
                                    isMerchatActions={this.props.isMerchatActions}
                                    getMerchantActions={this.props.getMerchantActions}
                                    caseStageId={this.props.caseStageId}
                                    openBoxDropDownStyle={this.props.openBoxDropDownStyle}
                                    regionCode={this.props.regionCode}
                                    setDataError={this.props.setDataError}
                                    globalToken={this.props.globalToken}
                                    setFilterModelAttribute={this.props.setFilterModelAttribute}
                                    appSerchUrl={this.props.appSerchUrl}
                                    isAutoHeight={this.props.isAutoHeight}
                                    deleteNotification={this.props.deleteNotification}
                                    archiveUnmatchedSchemeImage={this.props.archiveUnmatchedSchemeImage}
                                    dateFormat={this.props.dateFormat}
                                    timeFormat={this.props.timeFormat}
                                    isTransactionFlag={this.props.isTransactionFlag}
                                    reportName={this.props.reportName}
                                    isVisible={this.props.isVisible}
                                    isLocalSort={this.props.isLocalSort}
                                    isDataSearchTransaction={this.props.isDataSearchTransaction ? this.props.isDataSearchTransaction : false}
                                />
                            }
                            {!this.props.isAgGrid && <GDTableContainer
                                tableName={this.props.tableName}
                                user={this.props.user}
                                identifier={this.props.report.primaryColumnKey}
                                extraClass={this.props.className}
                                actionButtonText={this.props.actionButtonText}
                                columns={this.state.visibleColumns}
                                data={this.props.data}
                                dateFormat={this.props.dateFormat}
                                timeFormat={this.props.timeFormat}
                                sort={this.props.sort}
                                handleRowAction={this.props.handleRowAction}
                                handleSort={this.props.handleSort}
                                rowActions={rowActions}
                                onRowClick={this.props.onRowClick}
                                exportFileName={this.props.report.name}
                                actions={this.props.report.actions}
                                rowActionClick={this.props.rowActionClick}
                                loadDataOnScroll={this.props.loadDataOnScroll}
                                isPagable={this.props.isPagable}
                                openBoxDropDownStyle={this.props.openBoxDropDownStyle}
                                isLoading={this.props.isLoading}
                                isCheckboxOnRowRequired={this.props.isCheckboxOnRowRequired}
                                onCheckboxClick={this.props.onCheckboxClick}
                                selectedRows={this.props.selectedRows}
                                dragOvertText={this.props.dragOvertText}
                                onBookMarked={this.props.onBookMarked}
                                bookMarkedRows={this.props.bookMarkedRows}
                                isReport={this.props.isReport}
                            />}
                            {this.props.showFooter && this.props.isPagable && (
                                
                                <GDTableFooter
                                    tableCss = {this.props.tableCss}
                                    isrelatedSearchLoaded={this.props.isrelatedSearchLoaded}
                                    totalRecords={this.props.totalRecords}
                                    totalPages={this.props.totalPages}
                                    recordsCountText={this.props.recordsCountText}
                                    currentPage={this.props.currentPage}
                                    recordsShown={this.props.recordsShown}
                                    pageHandler={this.props.pageHandler}
                                    translations={this.props.translations}
                                    isNextPage={this.props.isNextPage}
                                    id={`${this.props.report.name}_GDTableFooter`}
                                    isPagable={this.props.isPagable}
                                />
                            )
                            }
                        </div>
                    </WizardAccordion>
                    {this.props.customFooter}</>
                )}
                {this.props.isFetchingData && <BVLoader20 />}
            </div>
        );
    }
}

GridAccordion.propTypes = {
    currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    canSearch: PropTypes.bool,
    data: PropTypes.array.isRequired,
    dateFormat: PropTypes.string.isRequired,
    timeFormat: PropTypes.string,
    exportAction: PropTypes.func,
    exporting: PropTypes.bool,
    extraClass: PropTypes.string,
    filterExportIsVisible: PropTypes.bool,
    filterText: PropTypes.string,
    handleRowAction: PropTypes.func,
    handleSort: PropTypes.func, // generalize to refresh API call with new sort param
    hasSummaryRow: PropTypes.bool, // if GET /reports/:reportId/summary returns anything
    isNextPage: PropTypes.bool,
    isFetchingData: PropTypes.bool,
    onRowClick: PropTypes.func,
    onRowClickDownload: PropTypes.func,
    onSearchChange: PropTypes.func,
    pageHandler: PropTypes.func.isRequired,
    recordsCountText: PropTypes.object.isRequired,
    recordsShown: PropTypes.number,
    report: PropTypes.object.isRequired,
    saveCurrentlyVisibleColumns: PropTypes.func,
    selectedCurrencyCode: PropTypes.string,
    sort: PropTypes.array.isRequired,
    summaryData: PropTypes.array,
    titleRequired: PropTypes.bool,
    toggleFileExport: PropTypes.func,
    totalPages: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    translations: PropTypes.object.isRequired,
    rowActionClick: PropTypes.func,
    isPagable: PropTypes.bool.isRequired,
    loadDataOnScroll: PropTypes.func,
    addIconsToGDTableHeadersList: PropTypes.func,
    timeBoxData: PropTypes.object,
    isCheckboxOnRowRequired: PropTypes.bool,
    showCaseCountDisplay: PropTypes.bool,
    headerCountDataColumn: PropTypes.array,
    headerCountData: PropTypes.object,
    onCheckboxClick: PropTypes.func,
    selectedRows: PropTypes.array,
    dragOvertText: PropTypes.string,
    onBookMarked: PropTypes.func,
    tableName: PropTypes.string,
    exportFileName: PropTypes.string,
    isAgGrid: PropTypes.bool,
    isNewQueueLanding: PropTypes.bool,
    onCloseClick: PropTypes.bool,
    isGridCompact: PropTypes.bool,
    isCellborder: PropTypes.bool,
    rowHeight: PropTypes.number,
    merchantDetail: PropTypes.object,
    isLocalSort: PropTypes.bool,
    customFooter: PropTypes.func,
    toggleAccordion: PropTypes.func,
    isOpen: PropTypes.bool,
};

GridAccordion.defaultProps = {
    toggleAccordion: () => { },
    isOpen: false,
    isAgGrid: false,
    canSearch: false,
    exportAction: null,
    exporting: false,
    extraClass: '',
    filterExportIsVisible: false,
    filterText: '',
    handleRowAction: null,
    handleSort: () => { },
    hasSummaryRow: false,
    isNextPage: false,
    isFetchingData: false,
    loadDataOnScroll: () => { },
    onRowClick: () => { },
    onRowClickDownload: () => { },
    onSearchChange: () => { },
    recordsShown: 25,
    saveCurrentlyVisibleColumns: () => { },
    selectedCurrencyCode: '',
    summaryData: [],
    toggleFileExport: () => { },
    rowActionClick: () => { },
    titleRequired: true,
    tableCss: '',
    addIconsToGDTableHeadersList: () => { },
    timeBoxData: {},
    isCheckboxOnRowRequired: false,
    showCaseCountDisplay: false,
    headerCountDataColumn: [],
    headerCountData: {},
    selectedRows: [],
    dragOvertText: '',
    isPagable: false,
    exportFileName: '',
    showFooter: true,
    isNewQueueLanding: false,
    onCloseClick: false,
    isGridCompact: false,
    isCellborder: false,
    rowHeight: 50,
    merchantDetail: null,
    isLocalSort: false
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(GridAccordion);
